import {
  ISmartpayPurchaseTransactionExtendedData,
  isPurchaseTransactionExtendedData,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import {
  getRefundInfo$,
  getRefundLabel$,
  getRefundRemaining$,
} from '../../transaction-helpers';
import { SmartpayQRPurchaseTransactionProvider } from '../smartpay-qr-purchase-transaction-provider.service';

export class RefundSmartpayQRPurchaseTransaction
  implements ITransactionAction<ISmartpayPurchaseTransactionExtendedData>
{
  icon = 'undo';
  label = 'Refund';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isPurchaseTransactionExtendedData;

  constructor(private _provider: SmartpayQRPurchaseTransactionProvider) {}

  canDo$(
    data: ITransactionActionsData<ISmartpayPurchaseTransactionExtendedData>
  ): Observable<boolean> {
    return getRefundRemaining$(data).pipe(
      map((remaining) => {
        const isIncoming = data.transaction.type === TransactionType.Incoming;
        const hasRemaining = remaining > 0;
        return isIncoming && hasRemaining;
      })
    );
  }

  label$(
    data: ITransactionActionsData<ISmartpayPurchaseTransactionExtendedData>
  ): Observable<string> {
    return getRefundLabel$(data);
  }

  info$(
    data: ITransactionActionsData<ISmartpayPurchaseTransactionExtendedData>
  ): Observable<string[]> {
    return getRefundInfo$(data);
  }

  async do(
    data: ITransactionActionsData<ISmartpayPurchaseTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._provider.refundTransaction(
      data.invoice,
      data.latestTransaction
    );
    this.inProgress$.next(false);
  }
}
